var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from '../../molecules';
import { Icon, TextBody } from '../../atoms';
export default function InfoPopoverWeb(_a) {
    var { content } = _a, rest = __rest(_a, ["content"]);
    return (_jsx(Popover, Object.assign({ placement: 'top-end', maxWidth: 200 }, rest, { trigger: _jsx(Icon, { name: "Info", color: "tertiary", size: "xs" }), children: _jsx(TextBody, { small: true, color: "primary", children: content }) })));
}
